import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import './Staff.css';
import PermissionMatrix from './PermissionMatrix';
import StaffFormSkeleton from './StaffFormSkeleton';

export default function StaffEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [form, setForm] = useState(null);
  const [newPass, setNewPass] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success');
  const show = (t, ty = 'success') => { setMessage(t); setType(ty); };

  useEffect(() => {
    (async () => {
      try {
        const [s, p] = await Promise.all([api.get(`/staff/${id}`), api.get('/staff/permissions')]);
        setGroups(p.data.groups);
        setForm(s.data.staff);
      } catch (err) {
        if (err.response?.status === 404) setNotFound(true);
        else show('خطا در دریافت اطلاعات', 'danger');
      }
    })();
  }, [id]);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post(`/staff/${id}/edit`, {
        fullName: form.fullName,
        isActive: form.isActive,
        permissions: form.permissions,
      });
      show('تغییرات ذخیره شد');
      setTimeout(() => navigate('/dashboard/staff'), 800);
    } catch (err) {
      show(err.response?.data?.error || 'خطا در ذخیره', 'danger');
    } finally {
      setSaving(false);
    }
  };

  const resetPass = async () => {
    if (newPass.length < 6) return show('رمز باید حداقل ۶ کاراکتر باشد', 'danger');
    try {
      await api.post(`/staff/${id}/reset-password`, { password: newPass });
      setNewPass('');
      show('رمز موقت تنظیم شد');
    } catch (err) {
      show(err.response?.data?.error || 'خطا', 'danger');
    }
  };

  if (notFound)
    return (
      <div className="card">
        <h2>پرسنل یافت نشد</h2>
        <Link className="btn secondary" to="/dashboard/staff">بازگشت</Link>
      </div>
    );
  if (!form) return  <StaffFormSkeleton />;

  return (
    <>
      {message && <div className={type === 'danger' ? 'toast-danger' : 'toast-success'}>{message}</div>}

      <form onSubmit={save}>
        <div className="card">
          <h2>ویرایش پرسنل — {form.phoneNumber}</h2>
          <div className="grid">
            <div>
              <label>نام و نام خانوادگی</label>
              <input value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} />
            </div>
            <div>
              <label>وضعیت</label>
              <select value={form.isActive ? '1' : '0'}
                onChange={(e) => setForm({ ...form, isActive: e.target.value === '1' })}>
                <option value="1">فعال</option>
                <option value="0">غیرفعال</option>
              </select>
            </div>
          </div>
        </div>

        <div className="card">
          <h2>دسترسی‌ها</h2>
          <PermissionMatrix groups={groups} value={form.permissions}
            onChange={(permissions) => setForm({ ...form, permissions })} />
        </div>

        <div className="flexend">
          <Link className="btn secondary" to="/dashboard/staff"><i className="fa-solid fa-xmark" /> انصراف</Link>
          <button className="btn" type="submit" disabled={saving}>
            {!saving && <i className="fa-solid fa-floppy-disk" />}
            {saving ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
          </button>
        </div>
      </form>

      <div className="card">
        <h2>بازنشانی رمز عبور</h2>
        <p className="section-sub">رمز موقت جدید تعیین کنید؛ کاربر در ورود بعدی باید آن را عوض کند.</p>
        <div className="grid">
          <input placeholder="رمز موقت جدید" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
          <div><button type="button" className="btn secondary" onClick={resetPass}>تنظیم رمز موقت</button></div>
        </div>
      </div>
    </>
  );
}